export default "__VITE_ASSET__f80de2f2__"